export default __webpack_public_path__ + "static/media/scan-bunifikasi-picturemark-d.1005d3b7.svg";